import Vue from 'vue'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import vqTabs from './components/vqTabs'
import vqAccordion from './components/vqAccordion.vue'
import * as promoModal from './js/promo-modal'
import smoothscroll from 'smoothscroll-polyfill';

import '../style/style.css'


smoothscroll.polyfill();

const requireComponent = require.context(
    // Le chemin relatif du dossier composants
    './components',
    // Suivre ou non les sous-dossiers
    true,
    // L'expression régulière utilisée pour faire concorder les noms de fichiers de composant de base
    /[A-Za-z]\w+\.(vue|js)$/
)
requireComponent.keys().forEach(fileName => {
  // Récupérer la configuration du composant
  const componentConfig = requireComponent(fileName)

  // Récupérer le nom du composant en PascalCase
  const componentName = upperFirst(
      camelCase(
          // Retrouver le nom du fichier indépendemment de la profondeur de dossier
          fileName
              .split('/')
              .pop()
              .replace(/\.\w+$/, '')
      )
  )

  // Créer un composant global
  Vue.component(
      componentName,
      // Chercher les options du composant dans `.default`, qui
      // existera si le composant a été exporté avec `export default`,
      // sinon revenez à la racine du module.
      componentConfig.default || componentConfig
  )
})

document
    .querySelectorAll('.vq-component')
    .forEach((el) => {
      new Vue({
        delimiters: ["[[", "]]"],
        el,
        components: {
          vqAccordion,
          vqTabs
        }
      })
    })

require("./apps/slider-staff");
require("./apps/slider-testimonials");
require("./apps/contact");
require('./apps/header')
require("./apps/faq");
require("./apps/news");
require("./js/promo-modal");
require("./js/video-modal");
require("./js/anchors.js");

